module.exports = __webpack_public_path__ + "play_button.6b33fbb1a50c03cc782b.png";


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/assets/img/play_button.png
// module id = ../../../../../src/assets/img/play_button.png
// module chunks = main